import "./Home.css";
import Banner from "../../Components/Banner/Banner";
import Featured from "../../Components/Featured/Featured";
import MostFavorite from "../../Components/MostFavorite/MostFavorite";
import InstaShop from "../../Components/InstaShop";
// ❌ Removed SkinTips & PersonalCare
import ShopByCategory from "../../Components/ShopByCategory";
import { Helmet } from "react-helmet-async";
import icon from "../../Images/ogIcon.png";
import HomeAbout from "../../Components/HomeAbout"; // This will now show FOOD-focused about section
import ShopByConcern from "../ShopByConcern/ShopByConcern"; // Will adapt for food categories (Healthy Heart, Immunity Boost, etc.)

const Home = () => {
  return (
    <div className="home bg-[#f5f5f0] overflow-hidden">
      <div>
        <Helmet>
          {/* ✅ Optimized Title for Food Section */}
          <title>
            Clariss Nutritions | Premium, Organic & Healthy Foods
          </title>

          {/* ✅ SEO Meta Description */}
          <meta
            name="description"
            content="Clariss Food Bangladesh brings premium, organic, and healthy foods sourced from nature. Eat clean, live healthy with Clariss."
          />

          {/* ✅ SEO Keywords */}
          <meta
            name="keywords"
            content="Clariss Food Bangladesh, olive oil Bangladesh, healthy food Bangladesh, organic food products, premium groceries, natural cooking essentials"
          />

          {/* ✅ Canonical URL */}
          <link rel="canonical" href="https://clariss.com.bd/food" />

          {/* ✅ Open Graph Tags for Social Media */}
          <meta
            property="og:title"
            content="Clariss Food Bangladesh – Healthy, Organic & Premium Food Products"
          />
          <meta
            property="og:description"
            content="Discover premium olive oil, organic pantry essentials & healthy foods with Clariss Food Bangladesh. Eat clean. Live well."
          />
          <meta property="og:image" content={icon} />
          <meta property="og:url" content="https://clariss.com.bd/food" />
          <meta property="og:type" content="website" />

          {/* ✅ Twitter Card for better social previews */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="Clariss Food Bangladesh | Premium Olive Oil & Healthy Foods"
          />
          <meta
            name="twitter:description"
            content="Clariss Food Bangladesh offers organic olive oil, natural groceries & healthy food essentials. Taste the goodness of nature."
          />
          <meta name="twitter:image" content={icon} />

          {/* ✅ JSON-LD Structured Data for SEO */}
          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "Clariss Food Bangladesh",
                "url": "https://clariss.com.bd/food",
                "logo": "https://clariss.com.bd/static/media/Clariss-Logo.63340c74383fffd01b19.webp",
                "description": "Clariss Food Bangladesh offers organic food essentials like premium olive oil, spices, and healthy pantry products.",
                "sameAs": [
                  "https://www.facebook.com/clarissbangladesh",
                  "https://www.instagram.com/clarissbangladesh",
                  "https://www.youtube.com/@clarissbangladesh"
                ],
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "16192 Coastal Highway",
                  "addressLocality": "Lewes",
                  "addressRegion": "Delaware",
                  "postalCode": "19958",
                  "addressCountry": "US",
                  "addressCounty": "Sussex County"
                },
                "contactPoint": {
                  "@type": "ContactPoint",
                  "telephone": "+8801 404 403 965",
                  "contactType": "customer service",
                  "availableLanguage": ["English", "Bengali"]
                }
              }
            `}
          </script>
        </Helmet>

        {/* ✅ Hidden SEO-friendly Main Heading */}
        <h1 className="sr-only">
          Clariss Food Bangladesh – Premium Olive Oil, Organic Groceries & Healthy Food Products
        </h1>

        {/* ✅ Core Sections */}
        <Banner /> 
        {/* <ShopByCategory />  */}
        <HomeAbout />
        {/* <ShopByConcern />  */}
        {/* <MostFavorite />  */}
        <Featured /> 
        <InstaShop /> 
      </div>
    </div>
  );
};

export default Home;
